// extracted by mini-css-extract-plugin
export var control = "cursorSlider-module--control--ccbb1";
export var controlWrapper = "cursorSlider-module--control-wrapper--53534";
export var innerRail = "cursorSlider-module--inner-rail--232e5";
export var input = "cursorSlider-module--input--2c8ae";
export var inputWrapper = "cursorSlider-module--input-wrapper--a2b17";
export var inputsWrapper = "cursorSlider-module--inputsWrapper--22640";
export var max = "cursorSlider-module--max--d13a1";
export var min = "cursorSlider-module--min--95713";
export var rail = "cursorSlider-module--rail--15663";
export var wrapper = "cursorSlider-module--wrapper--16320";